import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import DataTableComponent from '../../../../../../../../Util/DataTable/DataTable';
import { loadColumns } from '../../../../../../../../Util/helper';
import "./LeagueChampion.css";
import backArrow from "../../../../../../../../assets/arrow-back.svg";
import axiosApi from '../../../../../../../../core/interceptor/interceptor';
import { config } from '../../../../../../../../config';

const columns = loadColumns({
    columns: [
        {
            name: 'Player',
            selector: 'user.name',
            sortable: false,
        },
        {
            name: 'Email',
            selector: 'user.email',
            sortable: false,
        },
        {
            name: 'Captain',
            selector: 'isCaptain',
            type: 'awarded',
            sortable: false,
        },
        {
            name: 'Primary Phone',
            selector: 'user.cell_phone',
            sortable: false,
        },
        {
            name: 'Secondary Phone',
            selector: 'user.secondary_phone',
            sortable: false,
        },
        {
            name: 'Shirt Size',
            selector: 'user.shirt_size',
            sortable: false,
        }
    ]
});

export default function LeagueChampion() {
    const [awarded, setAwarded] = useState(false);
    const [data, setData] = useState();
    const id = useParams().id;
    const [league, setLeague] = useState('');
    const [team, setTeam] = useState('');
    const [teamId, setTeamId] = useState(0);
    const [seasonId, setSeasonId] = useState(0);


    useEffect(() => {
        getPlayers();


				function getPlayers() {
					axiosApi.get(`${config.apiUrl}/teams/team/players/${id}`)
							.then((resp) => {
									if (resp && resp.data && resp.data.data && resp.data.data.players) {
											resp.data.data.players.forEach(element => (element.isCaptain = element?.user_id === resp.data.data?.captain_id));
											setData(resp.data.data.players);
											setAwarded(resp.data.data.awarded);
											setLeague(resp.data.data?.league?.name);
											setTeam(resp.data.data.name);
											setTeamId(resp.data.data.id);
											setSeasonId(resp.data.data?.league?.season_id);
									}
							})
						}
    }, [id]);

    useEffect(() => {
        if (teamId > 0) {
            axiosApi.put(`${config.apiUrl}/teams/awarded/${teamId}`, { awarded })
                .then((resp) => {
                    if (resp) {
                    }
                })
        }
    }, [awarded,teamId]);

    return <>
        <div className="content-wrapper leagueChampion-wrapper">
            <div className="heading-blk">
                <Link to={{
                    pathname: '/admin/leagues/champions',
                    search: `?season_id=${seasonId}`
                }}><button className="back-btn"><img src={backArrow} alt="back-arrow" />Back to Champions</button></Link>
                <h2 className="heading">League Champion - {league}</h2>
            </div>
            <div className="table-wrapper">
                <div className="heading-blk">
                    <div className="left">
                        <h2>{team}</h2>
                    </div>
                </div>
                <div className="dataTable">
                    {/* <DataTableComponent key="table-admin-users" type={'user'} /> */}
                    <DataTableComponent
                        key="table-admin-users"
                        type={'league_champions_team'}
                        data={data}
                        columns={columns}
                        // onFilterChange={handleChange}
                        disableRowClicked={true}
                        totalPage={20} />
                </div>
            </div>
            <div className="awarded-blk">
                {
                    !awarded && <button onClick={() => setAwarded(o => !o)}>Mark Team As Awarded</button>
                }
                {
                    awarded &&
                    <div className="award-blk">
                        <h2>Team has been awarded</h2>
                        <span style={{ cursor: 'pointer' }} onClick={() => setAwarded(o => !o)}>Undo</span>
                    </div>
                }
            </div>
        </div>
    </>
}